module.exports = __webpack_public_path__ + "static/media/info.6b6e4d1f.svg";